import script from "./CensusDog.vue?vue&type=script&setup=true&lang=js"
export * from "./CensusDog.vue?vue&type=script&setup=true&lang=js"

import "./CensusDog.vue?vue&type=style&index=0&id=a6273afc&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6273afc"]])

export default __exports__